import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: "",
    authenticated: false,
    user: {}
  },
  mutations: {
    setToken(state, accessToken) {
      state.token = accessToken
      state.authenticated = true
    },
    setUser(state, accessUser) {
      state.user = accessUser
    }
  },
  actions: {
  },
  modules: {
  }
})
